import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {ButtonComponent} from '../../forms/button/button.component';


export interface DialogData {
  headerMessage:string,
  errorMessages:any,
}

@Component({
  selector: 'app-error-dialog',
  imports: [
    ButtonComponent,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle
  ],
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss'
})
export class ErrorDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

}
